import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { toCamel } from '../../helpers/string';
var LanguageSwitcher = function LanguageSwitcher(_ref) {
  var languages = _ref.languages,
    defaultLanguage = _ref.defaultLanguage,
    hideActive = _ref.hideActive;
  var entityType = useSelector(function (state) {
    return state.getIn(['entity', 'entityType'], null);
  });
  var entityId = useSelector(function (state) {
    return state.getIn(['entity', 'entityId'], null);
  });
  var entity = useSelector(function (state) {
    return state.getIn([entityType ? toCamel(entityType) : entityType, entityId], Immutable.Map());
  });
  var entityExists = useSelector(function (state) {
    return state.getIn(['entity', 'exists']);
  });
  var currentLanguage = useSelector(function (state) {
    return state.getIn(['ui', 'language']);
  });
  var path = useSelector(function (state) {
    // Strip any accidental trailing slash, as it would incorrectly fail the isActive
    // comparison further down.
    var statePath = state.getIn(['router', 'location', 'pathname']).replace(/\/$/, '');
    return statePath === '/' ? "/".concat(defaultLanguage) : statePath;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "LanguageSwitcher"
  }, /*#__PURE__*/React.createElement("ul", null, Object.keys(languages).map(function (langcode) {
    var defaultPath = "/".concat(langcode);
    var url = entity.getIn(['paths', langcode], defaultPath);

    // Check if this is an an entity and not a custom route
    var hasEntityUrl = typeof entity.getIn(['paths', langcode]) !== 'undefined';

    // If this entity doesn't exist, or we're at the frontpage. Create the new URL.
    if (!entityExists || entity.get('is_front')) {
      url = "/".concat(langcode).concat(path.replace(new RegExp("/".concat(currentLanguage)), ''));
    }
    var isActive = url === path;
    if (hideActive && isActive) {
      return true;
    }
    var classes = classNames("language-".concat(langcode), {
      'is-active': hasEntityUrl ? isActive : currentLanguage === langcode
    });
    return /*#__PURE__*/React.createElement("li", {
      className: classes,
      key: "language-switcher--url-".concat(langcode, ":").concat(url)
    }, /*#__PURE__*/React.createElement(Link, {
      to: url,
      className: "language-link"
    }, languages[langcode]));
  })));
};
LanguageSwitcher.propTypes = {
  languages: PropTypes.shape({}),
  defaultLanguage: PropTypes.string,
  hideActive: PropTypes.bool
};
LanguageSwitcher.defaultProps = {
  languages: {
    'nl': 'Nederlands',
    'en': 'English'
  },
  defaultLanguage: 'nl',
  hideActive: true
};
export default LanguageSwitcher;